/* eslint-disable */
import React from 'react';

function SVG({
  width = '128px',
  height = '128px',
  color = '#262F3F',
  opacity = '0.08',
}) {
  const primary = color;
  const primaryOpacity = opacity;

  // const secondary = '#37bdf8';
  // const secondaryOpacity = '0.25';

  const classes = {
    cls1: {
      fill: primary,
      fillRule: 'evenodd',
      fillOpacity: primaryOpacity,
    },
    cls2: {
      fill: primary,
      fillRule: 'evenodd',
      fillOpacity: primaryOpacity,
    },
  };

  const style = {
    width,
    height,
  };

  return (
    <svg
      id="Layer_1"
      data-name="Layer 1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 127.71 111.52"
      style={style}
    >
      <path
        {...classes.cls1}
        d="M133.16,89.48a3.43,3.43,0,0,0-4.68,1.28l-19.14,33.47h-57L24.52,74.7,50.23,29.79,72.62,68.24l2,3.35H40.91a3.44,3.44,0,0,0,0,6.87H78.62l19.5,33.21a3.33,3.33,0,0,0,5.74-3.36L78.52,64.78,56,26.46h55.61a3.43,3.43,0,1,0,0-6.86H50.14a3.43,3.43,0,0,0-3,1.72L17.6,73a3.42,3.42,0,0,0,0,3.39l29.8,53a3.42,3.42,0,0,0,3,1.75h61a3.43,3.43,0,0,0,3-1.73l20.12-35.2A3.45,3.45,0,0,0,133.16,89.48ZM144.4,73.32,124.6,38.76a3.44,3.44,0,1,0-6,3.42L135.5,71.59H96.85a3.44,3.44,0,0,0,0,6.87h44.57a3.44,3.44,0,0,0,3-5.14Z"
        transform="translate(-17.14 -19.6)"
      />
      <path
        {...classes.cls2}
        d="M103.15,37.51a3.42,3.42,0,0,0-4.69,1.23l-10,17.11a3.43,3.43,0,0,0,1.23,4.7A3.39,3.39,0,0,0,91.4,61a3.43,3.43,0,0,0,3-1.7l10-17.12A3.42,3.42,0,0,0,103.15,37.51Zm-30.43,52A3.43,3.43,0,0,0,68,90.73l-10.4,17.76a3.45,3.45,0,0,0,1.23,4.7,3.44,3.44,0,0,0,4.7-1.23L73.94,94.2A3.44,3.44,0,0,0,72.72,89.5Z"
        transform="translate(-17.14 -19.6)"
      />
      <path
        {...classes.cls1}
        d="M118.78,129v2.13h-.73V129h-.77v-.69h2.28V129Zm1.68,2.13h-.73V128.3h.93l.66,1.4.66-1.4h.93v2.82h-.74v-1.5l-.62,1.28h-.46l-.63-1.28Z"
        transform="translate(-17.14 -19.6)"
      />
    </svg>
  );
}

export default SVG;
